import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRadarRingOuter = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 302,
	height: 223,
	viewBox: "0 0 302 223",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M151 0.473C234.126 0.473 301.527 69.135 301.527 153.853C301.527 238.57 234.126 307.233 151 307.233C67.874 307.233 0.473 238.57 0.473 153.853C0.473 69.135 67.874 0.473 151 0.473Z",
		stroke: "url(#radar-ring-outer)",
		strokeWidth: .945
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
		id: "radar-ring-outer",
		x1: 151,
		y1: 0,
		x2: 151,
		y2: 223,
		gradientUnits: "userSpaceOnUse",
		children: [
			/* @__PURE__ */ _jsx("stop", {
				offset: .053,
				stopColor: "#0D081C"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: .168,
				stopColor: "#DFCBF5",
				stopOpacity: .7
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: .332,
				stopColor: "#DFCBF5",
				stopOpacity: .7
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: .75,
				stopColor: "#0D081C"
			})
		]
	}) })]
});
export default SvgRadarRingOuter;
